import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as marketingOptionsActions from '../../actions/marketing-options.actions';
import { IMarketingRequest } from '../../models/marketing-options.model';
import * as actions from '../../actions';
import * as fromPaymentMandateAction from '../../../payment-mandate/actions';
@Component({
  selector: 'app-marketing-options',
  templateUrl: './marketing-options.component.html',
  styleUrls: [
    // "./marketing-options.component.css",
    './marketing-options.component.desktop.css'
  ]
})
export class MarketingOptionsComponent {
  index: number = 0;
  stepIndex: number = 0;
  checked: boolean = true;
  items: any[];

  constructor(
    private router: Router,
    private store: Store
  ) {
    this.items = [{ label: 'Marketing' }, { label: 'Regulatory' }];
  }

  acceptMarketing(req) {
    this.stepIndex = 1;
    this.index = this.index === 2 ? 0 : this.index + 1;
    this.store.dispatch(marketingOptionsActions.loadMarketingOptions({ request: req }));
  }

  acceptRegulatory() {
    this.store.dispatch(actions.loadRegulatorySettingsFirstTimeCustomers());
  }

  downloadDoc(doc: string) {
    this.store.dispatch(actions.loadDownloadPopiDocs({ documentName: doc }));
  }
}
